import { Blockchain } from "@rarible/api-client"
import type { Address } from "viem"
import type { Chain } from "viem/chains"
import type { CurrencyConfig } from "../currency/types"
// Remove these runtime extensions after @rarible/api-client 1.156.104 is published to npm.
Object.assign(Blockchain, {
  ARC: "ARC",
  ARCTESTNET: "ARCTESTNET",
  FLUENT: "FLUENT",
})

export { Blockchain }

export type BlockExplorer = {
  url: string
  icon: string
  adress: string
}

export type BaseBlockchainConfig = {
  name: string
  chainId: number | string
  icon: string
  primaryCurrency: CurrencyConfig
  wrappedCurrency?: CurrencyConfig
  hostEnvironment: "mainnet" | "testnet" | "dev" | "beta"
  rpcUrls: RpcUrl[]
  unionApi: string
  apiKey: string
  isEvm: boolean
  blockExplorers: BlockExplorer[]
  addFundsLink?: string
  isTestnet: boolean
  stabilityProtocol?: StabilityProtocolConfig
}

export type StabilityProtocolConfig = {
  apiKey: string
  destinationAddress: Address
}

export type RpcUrl = {
  url: string
  isPublic: boolean
}

export type BlockchainConfig =
  | EclipseBlockchainConfig
  | EthereumBlockchainConfig
  | SolanaBlockchainConfig

export type EclipseBlockchainConfig = {
  blockchain: Blockchain.ECLIPSE
  marketProgramAddress: string
  wsEndpoint?: string
  isEvm: false
} & BaseBlockchainConfig

export type SolanaBlockchainConfig = {
  blockchain: Blockchain.SOLANA
  /** Solana marketplace program address — placeholder until custom contract is configured */
  marketProgramAddress: string
  /** Solana market identifier pubkey used to derive the `Market` PDA */
  marketIdentifier: string
  isEvm: false
} & BaseBlockchainConfig

export type ExchangeAddresses = {
  v2: string
  wrapper: string
}

export type TransferProxies = {
  nft: string
  erc721Lazy: string
  erc20: string
}

export type FactoriesAddresses = {
  erc721: string
  erc1155: string
}

export type CryptoPunksConfig = {
  marketContract: string
  wrapperContract: string
}

export type SudoswapConfig = {
  pairFactory: string
  pairRouter: string
}

export type EthereumBlockchainConfig = {
  isEvm: true
  basePath: string
  blockchain: Blockchain
  chainId: number
  chainName: string
  exchange: ExchangeAddresses
  transferProxies: TransferProxies
  feeConfigUrl: string
  testnet: boolean
  // Base fee is in basis points
  baseFee?: number
  feesVersion: "v2" | "v3"
  treasury?: string
  viem: Omit<Chain, "formatters" | "fees" | "serializers" | "custom">
  transferCurrencies?: CurrencyConfig[]
} & BaseBlockchainConfig
